import {HEADER_PARAMS_KEYS, LAYOUT_TYPE} from '../../utils/share'
import {_findObjKey} from '../../const/static'

/**
 * Created by JackCui on 2022/2/21
 */

export default {
  computed: {
    id () {
      return this.params?.id || this.$route.query?.id || ''
    },
    layoutApiName () {
      return this.params?.layoutApiName || this.$route.query?.layoutApiName || ''
    },
    objectApiName () {
      return this.params?.objectApiName || this.$route.query?.objectApiName || ''
    },
    tenantType () {
      return this.params?.tenantType || this.$route.query?.tenantType || ''
    },
    // 操作权
    operationApiName () {
      return this.params?.operationApiName || this.$route.query?.operationApiName || ''
    },
    layoutType () {
      return this.schema?.info?.type || ''
    },
    isEdit () {
      return _findObjKey(LAYOUT_TYPE, this.layoutType) === LAYOUT_TYPE.LAYOUT_TYPE_UPDATE
    },
    region () {
      return this.schema?.info?.region || 2
    },
    fieldMap () {
      return this.schema?.cache?.fieldMap || {}
    },
    buttonMap () {
      return this.schema?.cache?.buttonMap || {}
    },
    columnMap () {
      return this.schema?.cache?.columnMap || {}
    },
    headerParams () {
      return {
        [HEADER_PARAMS_KEYS.tenantType]: this.tenantType,
        [HEADER_PARAMS_KEYS.objectApiName]: this.objectApiName,
        [HEADER_PARAMS_KEYS.layoutApiName]: this.layoutApiName,
        [HEADER_PARAMS_KEYS.operationApiName]: this.operationApiName
      }
    },
    requestParams () {
      return {
        tenantType: this.tenantType,
        objectApiName: this.objectApiName,
        layoutApiName: this.layoutApiName,
        curAuthCode: this.operationApiName
      }
    }
  },
  methods: {
    getHeaderParams () {
      return this.headerParams
    },
    // 存储 从对象ref
    saveRef (name, ref) {
      this.refMap[name] = ref
    },
    // 是否是主对象
    isMain (objectApiName) {
      return objectApiName === this.objectApiName
    },
    // 匹配ref
    _getRef (tag, objectApiName) {
      const refName = objectApiName ? `${tag}_${objectApiName}` : tag
      return this.refMap[refName]
    },
    // 更新值
    _updateData (data) {
      this._provided.formData = data
    }
  }
}
